import {
  AcceptSupplierSignupInvitationMutationCgResponse,
  AcceptSupplierSignupInvitationMutationVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

export const ACCEPT_SUPPLIER_SIGNUP_INVITATION_MUTATION: TypedDocumentNode<
  AcceptSupplierSignupInvitationMutationCgResponse,
  AcceptSupplierSignupInvitationMutationVariables
> = gql`
  mutation AcceptSupplierSignupInvitation(
    $token: String!
    $input: AcceptSupplierSignupInvitationInput!
  ) {
    acceptSupplierSignupInvitation(token: $token, input: $input) {
      worksMembership {
        id
      }
    }
  }
`;
